import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const LocationsPage = lazy(() =>
  import('../../pages/settings/locations/LocationsPage').then((m) => ({
    default: m.LocationsPage,
  })),
);

export const Route = createFileRoute('/settings/locations')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <LocationsPage />
    </Suspense>
  ),
});
